// extracted by mini-css-extract-plugin
export const summary = "CruiseSummary-module--summary--yhuFb";
export const name = "CruiseSummary-module--name--1vTnH";
export const date = "CruiseSummary-module--date--WpBnL";
export const days = "CruiseSummary-module--days--GO0nd";
export const priceColumn = "CruiseSummary-module--price-column--2xAhZ";
export const price = "CruiseSummary-module--price--eOkMj";
export const promo = "CruiseSummary-module--promo--BY9KB";
export const cta = "CruiseSummary-module--cta--1Djwl";